// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-styles_header__2-OBX","logo":"Header-styles_logo__16nkr","spacerLeft":"Header-styles_spacerLeft__eH74i","spacerRight":"Header-styles_spacerRight__iJGuP"};